import {
  API_CALL_WIZARD_API_REQUEST,
  API_CALL_WIZARD_API_SUCCESS,
  API_CALL_WIZARD_API_ERROR,
} from '../../../constants/wizardActionNames';

// import { api } from '../../../utils/variables';
import { apiCallWizardApi } from '../../../apis/wizards';
import { addInitialWizardDataAction } from '../addWizard';

// Term/Life premium API may reject a low Sum Insured with a 422 whose message
// states the minimum it was bumped to, e.g.
// "...Your Sum Insured was increased to <b>  20,800 XCG</b> so you can continue."
// Pull that figure out so we can prepopulate the Sum Insured (faceAmount) field.
function extractIncreasedSumInsured(response) {
  if (!response) return null;
  const messages = [
    response?.responseDesc?.message,
    ...(Array.isArray(response?.payload)
      ? response.payload.map(item => item?.errors)
      : []),
  ].filter(message => typeof message === 'string');

  for (const message of messages) {
    const match = message.match(/increased to\s*(?:<b>)?\s*([\d,]+(?:\.\d+)?)/i);
    if (match) {
      const value = parseFloat(match[1].replace(/,/g, ''));
      if (!Number.isNaN(value)) {
        return value;
      }
    }
  }
  return null;
}

// The increased Sum Insured is returned on the 422 and 400 rejections, so these
// are the scenarios we react to. `responseDesc.code` carries the HTTP status
// on the error body (the app uses it the same way elsewhere, e.g. === 200).
function isIncreasedSumInsuredError(error) {
  const code = error?.responseDesc?.code;
  return code === 422 || code === 400;
}

// When the premium API rejects with a 422/400 carrying an increased Sum Insured,
// write it back to the faceAmount field so it is prepopulated for the user to
// continue.
export function maybeUpdateSumInsured(dispatch, error) {
  if (!isIncreasedSumInsuredError(error)) {
    return;
  }
  const increasedSumInsured = extractIncreasedSumInsured(error);
  if (increasedSumInsured == null) {
    return;
  }
  dispatch(
    addInitialWizardDataAction({
      desiredMonthlyPremium: increasedSumInsured,
      number_desiredMonthlyPremium: increasedSumInsured,
      formatted_desiredMonthlyPremium: increasedSumInsured.toLocaleString('en-US'),
      faceAmount: increasedSumInsured,
      number_faceAmount: increasedSumInsured,
      formatted_faceAmount: increasedSumInsured.toLocaleString('en-US'),
    }),
  );
}

function apiCallWizardError(err, savedKey, apiCall) {
  return {
    type: API_CALL_WIZARD_API_ERROR,
    payload: err,
    savedKey,
    apiCall,
  };
}

function apiCallWizardRequest(savedKey, disablePending, apiCall) {
  return {
    type: API_CALL_WIZARD_API_REQUEST,
    payload: !disablePending,
    savedKey,
    apiCall,
  };
}
function apiCallWizardSuccess(prod, savedKey, params, oldStoreData, apiCall, lobTypes) {
  return {
    type: API_CALL_WIZARD_API_SUCCESS,
    payload: prod,
    savedKey,
    params,
    oldStoreData,
    apiCall,
    lobTypes,
  };
}

export function apiCallWizardAction(url, params, apiCall, savedKey, disablePending) {
  return (dispatch, getState) => {
    const state = getState();
    const lobTypes = state?.locations?.lobCategories;
    const oldStoreData = {};

    if (savedKey === 'accounts' || savedKey === 'accountCalculations') {
      oldStoreData.accounts =
        state?.investments?.initialAccounts &&
          state?.investments?.initialAccounts.length > 0
          ? state?.investments?.initialAccounts
          : null;
    }
    dispatch(apiCallWizardRequest(savedKey, disablePending, apiCall));
    return apiCallWizardApi
      .apiCallWizard(state, url, params, apiCall?.httpMethod, apiCall?.opts)
      .then(data => {
        // Update the app state with the results of the API call.
        dispatch(
          apiCallWizardSuccess(data, savedKey, params, oldStoreData, apiCall, lobTypes),
        );
        return data;
      })
      .catch(error => {
        dispatch(apiCallWizardError(error, savedKey, apiCall));
        // Only the 422 rejection carries an increased Sum Insured to prepopulate.
        maybeUpdateSumInsured(dispatch, error);
        throw error;
      });
  };
}

export default {
  apiCallWizardAction,
};
